// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: guardrails.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "guardrails";

export enum GuardrailName {
  GUARDRAIL_NAME_UNSPECIFIED = 0,
  GUARDRAIL_NAME_JAILBREAK_DEFENCE = 1,
  GUARDRAIL_NAME_HALLUCINATION_CONTROL = 2,
  GUARDRAIL_NAME_AI_IDENTITY = 3,
  GUARDRAIL_NAME_EMERGENCY_ESCALATION = 4,
  GUARDRAIL_NAME_TOOL_CALL_INTEGRITY = 5,
  UNRECOGNIZED = -1,
}

export function guardrailNameFromJSON(object: any): GuardrailName {
  switch (object) {
    case 0:
    case "GUARDRAIL_NAME_UNSPECIFIED":
      return GuardrailName.GUARDRAIL_NAME_UNSPECIFIED;
    case 1:
    case "GUARDRAIL_NAME_JAILBREAK_DEFENCE":
      return GuardrailName.GUARDRAIL_NAME_JAILBREAK_DEFENCE;
    case 2:
    case "GUARDRAIL_NAME_HALLUCINATION_CONTROL":
      return GuardrailName.GUARDRAIL_NAME_HALLUCINATION_CONTROL;
    case 3:
    case "GUARDRAIL_NAME_AI_IDENTITY":
      return GuardrailName.GUARDRAIL_NAME_AI_IDENTITY;
    case 4:
    case "GUARDRAIL_NAME_EMERGENCY_ESCALATION":
      return GuardrailName.GUARDRAIL_NAME_EMERGENCY_ESCALATION;
    case 5:
    case "GUARDRAIL_NAME_TOOL_CALL_INTEGRITY":
      return GuardrailName.GUARDRAIL_NAME_TOOL_CALL_INTEGRITY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GuardrailName.UNRECOGNIZED;
  }
}

export function guardrailNameToJSON(object: GuardrailName): string {
  switch (object) {
    case GuardrailName.GUARDRAIL_NAME_UNSPECIFIED:
      return "GUARDRAIL_NAME_UNSPECIFIED";
    case GuardrailName.GUARDRAIL_NAME_JAILBREAK_DEFENCE:
      return "GUARDRAIL_NAME_JAILBREAK_DEFENCE";
    case GuardrailName.GUARDRAIL_NAME_HALLUCINATION_CONTROL:
      return "GUARDRAIL_NAME_HALLUCINATION_CONTROL";
    case GuardrailName.GUARDRAIL_NAME_AI_IDENTITY:
      return "GUARDRAIL_NAME_AI_IDENTITY";
    case GuardrailName.GUARDRAIL_NAME_EMERGENCY_ESCALATION:
      return "GUARDRAIL_NAME_EMERGENCY_ESCALATION";
    case GuardrailName.GUARDRAIL_NAME_TOOL_CALL_INTEGRITY:
      return "GUARDRAIL_NAME_TOOL_CALL_INTEGRITY";
    case GuardrailName.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Guardrail {
  name: GuardrailName;
  enabled: boolean;
}

export interface Guardrails {
  guardrails: Guardrail[];
  updatedBy?: string | undefined;
  updatedAt?: Date | undefined;
}

/** Command payload */
export interface GuardrailsUpdateGuardrails {
  guardrails: Guardrail[];
}

function createBaseGuardrail(): Guardrail {
  return { name: 0, enabled: false };
}

export const Guardrail: MessageFns<Guardrail> = {
  encode(message: Guardrail, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== 0) {
      writer.uint32(8).int32(message.name);
    }
    if (message.enabled !== false) {
      writer.uint32(16).bool(message.enabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Guardrail {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuardrail();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.name = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Guardrail {
    return {
      name: isSet(object.name) ? guardrailNameFromJSON(object.name) : 0,
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
    };
  },

  toJSON(message: Guardrail): unknown {
    const obj: any = {};
    if (message.name !== 0) {
      obj.name = guardrailNameToJSON(message.name);
    }
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    return obj;
  },

  create(base?: DeepPartial<Guardrail>): Guardrail {
    return Guardrail.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Guardrail>): Guardrail {
    const message = createBaseGuardrail();
    message.name = object.name ?? 0;
    message.enabled = object.enabled ?? false;
    return message;
  },
};

function createBaseGuardrails(): Guardrails {
  return { guardrails: [], updatedBy: undefined, updatedAt: undefined };
}

export const Guardrails: MessageFns<Guardrails> = {
  encode(message: Guardrails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.guardrails) {
      Guardrail.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.updatedBy !== undefined) {
      writer.uint32(18).string(message.updatedBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Guardrails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuardrails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guardrails.push(Guardrail.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Guardrails {
    return {
      guardrails: globalThis.Array.isArray(object?.guardrails)
        ? object.guardrails.map((e: any) => Guardrail.fromJSON(e))
        : [],
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: Guardrails): unknown {
    const obj: any = {};
    if (message.guardrails?.length) {
      obj.guardrails = message.guardrails.map((e) => Guardrail.toJSON(e));
    }
    if (message.updatedBy !== undefined) {
      obj.updatedBy = message.updatedBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<Guardrails>): Guardrails {
    return Guardrails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Guardrails>): Guardrails {
    const message = createBaseGuardrails();
    message.guardrails = object.guardrails?.map((e) => Guardrail.fromPartial(e)) || [];
    message.updatedBy = object.updatedBy ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    return message;
  },
};

function createBaseGuardrailsUpdateGuardrails(): GuardrailsUpdateGuardrails {
  return { guardrails: [] };
}

export const GuardrailsUpdateGuardrails: MessageFns<GuardrailsUpdateGuardrails> = {
  encode(message: GuardrailsUpdateGuardrails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.guardrails) {
      Guardrail.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GuardrailsUpdateGuardrails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGuardrailsUpdateGuardrails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.guardrails.push(Guardrail.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GuardrailsUpdateGuardrails {
    return {
      guardrails: globalThis.Array.isArray(object?.guardrails)
        ? object.guardrails.map((e: any) => Guardrail.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GuardrailsUpdateGuardrails): unknown {
    const obj: any = {};
    if (message.guardrails?.length) {
      obj.guardrails = message.guardrails.map((e) => Guardrail.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<GuardrailsUpdateGuardrails>): GuardrailsUpdateGuardrails {
    return GuardrailsUpdateGuardrails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GuardrailsUpdateGuardrails>): GuardrailsUpdateGuardrails {
    const message = createBaseGuardrailsUpdateGuardrails();
    message.guardrails = object.guardrails?.map((e) => Guardrail.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
